export default {
    filters: {
        cleanLabel(value) {
            return isNaN(value) ? value.toLowerCase().replace(' ', '-') : value;
        }
    },
}